/* Fit the review rail to its visible cards, keeping every review intact. */
(() => {
  const selector = '[id$="__1679700624d14a65bb"]';
  const initialized = new WeakSet();
  function init() {
    const section = document.querySelector(selector);
    const rail = section && section.querySelector('.carouselPre');
    if (!rail || initialized.has(rail)) return;
    initialized.add(rail);
    let frame = 0;
    const observed = new WeakSet();
    const observer = new ResizeObserver(schedule);
    function fit() {
      frame = 0;
      if (!rail.isConnected || rail.clientWidth === 0) return;
      const bounds = rail.getBoundingClientRect();
      let height = 0;
      rail.querySelectorAll('.itemsC').forEach(card => {
        if (!observed.has(card)) {
          observed.add(card);
          observer.observe(card);
        }
        const rect = card.getBoundingClientRect();
        const overlap = Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left);
        if (rect.width > 0 && overlap > 2) height = Math.max(height, rect.height);
      });
      if (!height) return;
      const style = getComputedStyle(rail);
      const target = Math.ceil(height + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
      if (Math.abs(rail.getBoundingClientRect().height - target) > 1) rail.style.height = target + 'px';
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(fit);
    }
    observer.observe(rail);
    new MutationObserver(schedule).observe(rail, { childList: true, subtree: true });
    rail.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', init);
})();
